// @flow
import React from 'react'

type Props = {
  status: string,
  marginLeft?: string,
  borderRadius?: string
}
const PRStatusBadge = (props: Props): React$Element<'div'> => (
  <div className='pr-status' style={{
    backgroundColor: props.status === 'open' ? '#2cbe4e' : '#d3443b',
    color: 'white',
    marginLeft: props.marginLeft || '5px',
    borderRadius: props.borderRadius || '3px',
    padding: '2px 5px',
    textTransform: 'capitalize',
    fontSize: 10
  }}>
    {props.status}
  </div>
)

export default PRStatusBadge



// WEBPACK FOOTER //
// ./app/javascript/packs/components/pull_request/PRStatusBadge.js